<template lang="pug">
  div.main-content
    el-row.margin-bottom
      el-col(:span="24")
        h1.titulo-pagina Upload de Planta
        p.descricao-pagina Faça upload de arquivos ZIP contendo plantas PDF para processamento automático (máximo 500MB)

    // Seção de Upload
    el-row.margin-bottom
      el-col(:span="24")
        el-card
          div(slot="header")
            span Fazer Upload
            el-button.float-right(size="small" v-if="showListagem" @click="showListagem = false")
              | Fazer Novo Upload
          el-row
            div.upload-area-wrapper(v-if="!showListagem")
              app-upload-area(
                id="upload-planta"
                :fileType="['zip']"
                :target="urlUpload"
                :hasDownloadButton="false"
                :maxSize="524288000"
                :onSuccess="onUploadSuccess"
                :onError="onUploadError"
                :onProgress="onUploadProgress"
                @removerDocumento="removerDocumento"
              )
          el-row.container-assinatura
            el-col(:span="24" v-if="!showListagem")
              el-switch(
                v-model="inserirAssinatura"
                active-text="Inserir assinatura na planta"
              )
          el-row.margin-top(v-if="uploadProgress > 0 && uploadProgress < 100 && !showListagem")
            el-col(:span="24")
              el-progress(:percentage="uploadProgress" :text-inside="true" :stroke-width="20")

          el-row.margin-top(v-if="uploadKey && !showListagem")
            el-col(:span="24")
              el-alert(
                title="Arquivo carregado com sucesso!"
                description="Clique no botão abaixo para processar o arquivo ZIP e extrair os dados das plantas PDF."
                type="success"
                show-icon
                :closable="false"
              )
              br
              el-button(type="primary" @click="processarArquivo" :loading="processando" size="large")
                | Processar Arquivo ZIP

    // Seção de Resultados
    el-row.margin-bottom(v-if="resultadoProcessamento && !showListagem")
      el-col(:span="24")
        el-card
          div(slot="header")
            span Resultado do Processamento

          el-alert(
            v-if="resultadoProcessamento.sucesso"
            title="Processamento Concluído"
            :description="`${resultadoProcessamento.totalProcessados} arquivo(s) processado(s) com sucesso`"
            type="success"
            show-icon
          )

          el-alert(
            v-else
            title="Erro no Processamento"
            :description="resultadoProcessamento.mensagem"
            type="error"
            show-icon
          )

          el-row.margin-top(v-if="resultadoProcessamento.sucesso")
            el-col(:span="24")
              el-button(type="primary" @click="verListagem")
                | Ver Arquivos Processados

    // Seção de Listagem
    el-row(v-if="showListagem")
      el-col(:span="24")
        el-card
          div(slot="header")
            span Arquivos Processados
            div.float-right
              el-button(size="small" @click="voltarUpload") Voltar ao Upload

          // Filtros
          .filter-row
            el-row(:gutter="20")
              el-col(:span="5")
                el-input(v-model="filtros.quadra" placeholder="Filtrar por quadra" clearable)
              el-col(:span="5")
                el-input(v-model="filtros.lote" placeholder="Filtrar por lote" clearable)
              el-col(:span="8")
                el-input(v-model="filtros.empreendimento" placeholder="Filtrar por bairro" clearable)
              el-col(:span="3")
                el-button(type="primary" @click="buscarRegistros" style="width: 100%") Filtrar
              el-col(:span="3")
                el-button(@click="limparFiltros" style="width: 100%") Limpar

          // Tabela
          el-table(
            :data="registros.content || []"
            style="width: 100%"
            v-loading="carregandoListagem"
          )
            el-table-column(prop="nomeArquivo" label="Arquivo" min-width="150")
            el-table-column(prop="municipio" label="Município" min-width="150")
            el-table-column(prop="empreendimento" label="Bairro" min-width="200")
            el-table-column(prop="quadra" label="Quadra" width="80")
            el-table-column(prop="lote" label="Lote" width="80")
            el-table-column(prop="area" label="Área" width="100")
            el-table-column(prop="vinculado" label="Status" width="100")
              template(slot-scope="scope")
                el-tag(:type="scope.row.vinculado ? 'success' : 'info'")
                  | {{ scope.row.vinculado ? 'Vinculado' : 'Pendente' }}
            el-table-column(prop="dataUpload" label="Data Upload" width="120")
              template(slot-scope="scope")
                | {{ formatarData(scope.row.dataUpload) }}
            el-table-column(prop="dataVinculacao" label="Data Vinculação" width="120")
              template(slot-scope="scope")
                | {{ formatarData(scope.row.dataVinculacao) }}
            el-table-column(label="Ações" width="100")
              template(slot-scope="scope")
                el-button(
                  v-if="!scope.row.vinculado && scope.row.tipo !== 'PLANTA'"
                  size="mini"
                  type="primary"
                  @click="vincularProcesso(scope.row)"
                ) Vincular

          // Paginação
          el-pagination(
            :current-page="currentPage"
            :page-size="pageSize"
            :total="registros.totalElements || 0"
            layout="prev, pager, next, sizes, total"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          )
    // Modal para vinculação
    el-dialog.vincular-modal(title="Vincular ao Processo" :visible.sync="dialogVincular" width="500px")
      el-form(:model="vincularForm" label-width="160px")
        el-form-item(label="Arquivo:")
          p {{ vincularForm.registro ? vincularForm.registro.nomeArquivo : '' }}
        el-form-item(label="Número do Processo:")
          el-input(v-model="vincularForm.numeroProcesso" placeholder="Digite o número do processo (ex: RO202500001234)")

      div(slot="footer")
        el-button(@click="dialogVincular = false") Cancelar
        el-button(type="primary" @click="confirmarVinculacao") Confirmar
</template>

<script>
import AppUploadArea from '@/components/AppUploadArea'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import { mapActions } from 'vuex'
export default {
  name: 'UploadPlanta',
  components: {
    AppUploadArea
  },

  mixins: [AppNotificacao],

  data () {
    return {
      urlUpload: this.$rotas.PUBLICO.UPLOAD,
      uploadKey: null,
      uploadProgress: 0,
      processando: false,
      resultadoProcessamento: null,
      showListagem: false,
      carregandoListagem: false,
      registros: {},
      currentPage: 1,
      pageSize: 20,
      filtros: {
        quadra: '',
        lote: '',
        empreendimento: ''
      },
      dialogVincular: false,
      vincularForm: {
        numeroProcesso: '',
        registro: null
      },
      executandoVinculacao: false,
      inserirAssinatura: true
    }
  },

  mounted () {
    this.buscarRegistros()
    this.showListagem = true // Mostrar listagem por padrão
  },

  methods: {
    ...mapActions({
      processarZip: 'processamentoPlanta/processarZip',
      listarRegistros: 'processamentoPlanta/listarRegistros',
      vincularProcessoAction: 'processamentoPlanta/vincularProcesso',
      executarVinculacaoAutomaticaAction: 'processamentoPlanta/executarVinculacaoAutomatica',
      getMunicipioById: 'municipios/findMunicipioById'
    }),

    onUploadSuccess (id, value, fileKey) {
      console.log('Upload success - id:', id, 'value:', value, 'fileKey:', fileKey)
      this.uploadKey = fileKey
      this.uploadProgress = 100
      this.showSuccess('Upload realizado com sucesso! Clique em "Processar Arquivo ZIP" para continuar.')
    },

    removerDocumento (id) {
      this.uploadKey = null
    },

    onUploadError (error) {
      this.showError('Erro no upload: ' + error)
      this.uploadProgress = 0
    },

    onUploadProgress (percentage) {
      this.uploadProgress = percentage
    },

    async mapMunicipios (content) {
      if (!Array.isArray(content) || content.length === 0) return []

      const cache = new Map()

      for (const item of content) {
        try {
          const municipioId = item?.municipio
          if (!municipioId) {
            item.municipio = '-'
            continue
          }

          if (cache.has(municipioId)) {
            item.municipio = String(cache.get(municipioId)).trim()
            continue
          }

          const municipioBuscado = await this.getMunicipioById(municipioId)
          const nome = municipioBuscado?.nome ? String(municipioBuscado.nome).trim() : '-'

          cache.set(municipioId, nome)
          item.municipio = nome
        } catch (e) {
          console.error('Error: ', e)
          item.municipio = '-'
        }
      }

      return content
    },

    async processarArquivo () {
      console.log('Iniciando processamento - uploadKey:', this.uploadKey)

      if (!this.uploadKey) {
        this.showWarning('Nenhum arquivo foi carregado')
        return
      }

      this.processando = true

      try {
        // Processar o arquivo ZIP enviando apenas a key
        console.log('Enviando key para processamento:', this.uploadKey)
        const resultado = await this.processarZip({
          fileKey: this.uploadKey,
          inserirAssinatura: this.inserirAssinatura
        })
        console.log('Resultado do processamento:', resultado)

        this.resultadoProcessamento = resultado

        if (resultado.sucesso) {
          this.showSuccess('Arquivo processado com sucesso!')
        } else {
          this.showError(resultado.mensagem || 'Erro no processamento')
        }
      } catch (error) {
        console.error('Erro ao processar arquivo:', error)
        this.showError('Erro ao processar arquivo')
      } finally {
        this.processando = false
      }
    },

    async buscarRegistros () {
      this.carregandoListagem = true

      try {
        const params = {
          page: this.currentPage - 1,
          size: this.pageSize,
          sort: 'dataUpload,desc'
        }

        if (this.filtros.quadra) params.quadra = this.filtros.quadra
        if (this.filtros.lote) params.lote = this.filtros.lote
        if (this.filtros.empreendimento) params.empreendimento = this.filtros.empreendimento

        this.registros = await this.listarRegistros(params)
        this.registros.content = await this.mapMunicipios(this.registros.content)
      } catch (error) {
        console.error('Erro ao buscar registros:', error)
        this.showError('Erro ao carregar listagem')
      } finally {
        this.carregandoListagem = false
      }
    },

    vincularProcesso (registro) {
      this.vincularForm.registro = registro
      this.vincularForm.numeroProcesso = ''
      this.dialogVincular = true
    },

    async confirmarVinculacao () {
      if (!this.vincularForm.numeroProcesso || this.vincularForm.numeroProcesso.trim() === '') {
        this.showWarning('Digite o número do processo')
        return
      }

      try {
        await this.vincularProcessoAction({
          id: this.vincularForm.registro.id,
          numeroProcesso: this.vincularForm.numeroProcesso.trim()
        })

        this.showSuccess('Memorial vinculado com sucesso!')
        this.dialogVincular = false

        this.buscarRegistros()
      } catch (error) {
        console.error('Erro ao vincular:', error)
      }
    },

    verListagem () {
      this.showListagem = true
      this.buscarRegistros()
    },

    voltarUpload () {
      this.showListagem = false
      this.resultadoProcessamento = null
      this.uploadKey = null
      this.uploadProgress = 0
    },

    handleCurrentChange (page) {
      this.currentPage = page
      this.buscarRegistros()
    },

    handleSizeChange (size) {
      this.pageSize = size
      this.currentPage = 1
      this.buscarRegistros()
    },

    async executarVinculacaoAutomatica () {
      try {
        this.executandoVinculacao = true

        await this.executarVinculacaoAutomaticaAction()

        this.showSuccess('Vinculação automática executada com sucesso!')
        this.buscarRegistros()
      } catch (error) {
        console.error('Erro ao executar vinculação automática:', error)
        this.showError('Erro ao executar vinculação automática')
      } finally {
        this.executandoVinculacao = false
      }
    },

    limparFiltros () {
      this.filtros.quadra = ''
      this.filtros.lote = ''
      this.filtros.empreendimento = ''
      this.currentPage = 1
      this.buscarRegistros()
    },

    formatarData (dateData) {
      if (!dateData) return '-'
      let date
      // Se for array (formato do Java LocalDateTime)
      if (Array.isArray(dateData)) {
        // [ano, mês, dia, hora, minuto, segundo, nanossegundo]
        const [ano, mes, dia, hora, minuto, segundo] = dateData
        // Mês no JavaScript é 0-based, então subtraimos 1
        date = new Date(ano, mes - 1, dia, hora, minuto, segundo)
      } else {
        // Se for string ISO normal
        date = new Date(dateData)
      }
      // Verificar se a data é válida
      if (isNaN(date.getTime())) return '-'
      return date.toLocaleDateString('pt-BR')
    }
  }
}
</script>

<style scoped>
.main-content {
  padding: 20px;
}

.titulo-pagina {
  color: #303133;
  margin-bottom: 10px;
}

.descricao-pagina {
  color: #606266;
  margin-bottom: 20px;
}

.upload-area-wrapper {
  padding: 20px;
}

/* Melhorias de espaçamento nos filtros */
.filter-row {
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 6px;
  margin-bottom: 20px;
}

/* Espaçamento nos cards */
.el-card {
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.el-card__header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

/* Botões com espaçamento consistente */
.button-group {
  display: flex;
  gap: 10px;
  align-items: center;
}

/* Modal de vinculação */
.vincular-modal .el-form-item {
  margin-bottom: 20px;
}

.margin-bottom {
  margin-bottom: 20px;
}

.margin-top {
  margin-top: 20px;
}

.container-assinatura {
  margin-top: 20px;
  margin-bottom: 20px;
}

.float-right {
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/uploadPlanta/UploadPlanta.vue